/*
 * 詳細画面定義コンポーネント
 */
<template>
<div>
	<!-- use the modal component, pass in the prop -->
	<components
		:is="comp_funcdetail"
		ref="func"
		:r_type='r_type'
		:r_type_maincode='r_type_maincode'
		:r_class_code="r_class_code"
		:r_code="m_strCode"
		:r_code2="m_strCode2"
		:r_code_name="r_code_name"
		:r_code2_name="r_code2_name"
		:r_src="r_info"
		:r_info="m_info"
		:r_is_new="m_bNew"
		:r_settings = "r_settings"
		:r_messages = "r_messages"
		@event_state_change="onFuncStateChanged"
		@event_update_end="onUpdateEnd"
		@event_refresh_end="onRefreshEnd"
		@event_next_refresh_end="onNextRefreshEnd"
		@event_freenumsearch_end="onFreeNumSearchEnd"
		@event_subfreenumsearch_end="onSubFreeNumSearchEnd"
	></components>
	<c-viewdialog
		r_dragid="detail"
		:r_is_first="r_is_first"
		:r_title="get_title"
		:r_subtitle="get_title_class_name"
		:r_is_resize_max_height="false"
		@event_cancel="onBtnClose"
	>
		<div v-if="r_is_previous_next_btn" slot="subtitle" class="previous-next-btn">
			<!-- <button class="btn-previous fa fa-angle-left" @click="onBtnPrevious" ></button>
			<button class="btn-next fa fa-angle-right" @click="onBtnNext" ></button> -->
			<button class="btn-previous" @click="onBtnPrevious"><i class="fa-solid fa-angle-left"></i></button>
			<button class="btn-next" @click="onBtnNext"><i class="fa-solid fa-angle-right"></i></button>
		</div>
		<div slot="content">
			<c-btns-wnd-detail
				v-if="r_settings.edit_right"
				:r_messages = "r_messages"
				:r_btn_type = "r_btn_type"
				:r_is_apply = "r_is_apply"
				:r_is_confirm_enable = "m_bConfirmEnable"
				:r_is_copy_enable = "m_bCopyEnable"
				:r_is_delete_enable = "m_bDeleteEnable"
				:r_is_restore_enable = "m_bRestoreEnable"
				:r_is_disp_new_btn = "m_bNewDataDisp"
				:r_is_disp_edit_btn = "m_bEditDataDisp"
				:r_check_edit = "check_edit"
				:r_is_disp_copy_btn = "m_bCopyDisp"
				:r_is_disp_delete_btn = "m_bDeleteDisp"
				:r_is_disp_errdetail_btn = "m_bErrDetailDisp"
				@event_btnoK="onBtnOK"
				@event_btncopy_new="onBtnCopyNew"
				@event_btndelete="onBtnDelete"
				@event_btnrestore="onBtnRestore"
				@event_btnnewdata="onBtnNewData"
				@event_btneditdata="onBtnEditData"
				@event_btnerrdetail="onBtnErrDetail"
			>
			</c-btns-wnd-detail>
			<!-- メッセージ -->
			<div v-if="r_btn_type != 0" class="message-space">
				<div class="clearfix" id="disp-err-msg">
					<c-message-accordion
						ref="v_msg"
						:error_messages = "m_message"
					>
					</c-message-accordion>
				</div>
			</div>
			<!-- 詳細表示 -->
			<components
				:is="comp_viewparam"
				ref="v_param"
				:r_messages = "r_messages"
				:r_settings = "r_settings"
				:r_class_code="r_class_code"
				:r_class_name="r_class_name"
				:r_code.sync="m_strCode"
				:r_code2="m_strCode2"
				:r_info.sync="m_info"
				:r_code_name="r_code_name"
				:r_code2_name="r_code2_name"
				:r_is_new="m_bNew"
				:r_is_subplu_code_max="r_is_subplu_code_max"
				@event_close="onClose"
				@keyup.enter="onKeyup"
				@event_code_change="onCodeChange"
				@event_code_change2="onCodeChange2"
				@event_state_change="onViewStateChange"
				@event_btn_copysearch="onBtnCopySearch"
				@event_btn_freenumsearch="onBtnFreeNumSearch"
				@event_btn_subfreenumsearch="onBtnSubFreeNumSearch"
				@event_errmessage="onErrMessage"
				@event_successmessage="setSuccessMessage"
				@event_end_copy_info="onEndCopyInfo"
				@focus_date='onFocusDate'
				@blur_date='onBlurDate'
			>
			</components>
			<!-- コピー元選択 -->
			<div id="copysearch-window">
				<components
					:is="comp_copysearch"
					ref="v_cpsearch"
					v-if="m_bCopySearchDisp"
					:r_type="type_copy"
					:r_is_first="r_is_first"
					:r_messages="r_messages"
					:r_settings="r_settings"
					:r_class_code="r_class_code"
					:r_class_name="r_class_name"
					:r_code="m_strCode"
					:r_code2="m_strCode2"
					:r_info="m_infoEdit"
					:r_comp_list="r_comp_copysearch_list"
					:r_comp_ifsearch="r_comp_copysearch_ifsearch"
					:r_comp_listmain="r_comp_copysearch_listmain"
					:r_comp_check="r_comp_copysearch_check"
					r_isbtnreturn="true"
					@event_end_copysearch="onEndCopySearch"
					@event_close="onCloseCopySearch"
				>
				</components>
			</div>
		</div>
	</c-viewdialog>
</div>
</template>
<script>
	/**
	 * 詳細画面定義コンポーネント.<br>
	 * @module js/parts_com/wndDetail
	 * @example
	 * <c-detail
	 * 	url={{$url}}
	 * 	:messages = "{{$messages}}"
	 * 	:r_settings = "{{$settingsJson}}"
	 * 	:is_new="false"
	 * 	v-on:event_close="onClose"
	 * >
	 * </c-detail>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_url - URL
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {string[]} r_is_new - 新規フラグ
	 * @param {object} r_info - 編集するデータ
	 **/
	export default {
		mixins: [
			require('js/common/wndDetail2.mixin.vue'),
		],
	}

</script>


// WEBPACK FOOTER //
// resources/assets/js/parts_com/wndDetail2.vue